import styled from 'styled-components';

export const PrivacyWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
`;
export const PrivacyHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  h2 {
    font-size: 28px;
    line-height: 24px;
    color: #d0201d;
    font-weight: 900;
  }
`;

export const PrivacyHeaderHeading = styled.div`
  margin-bottom: 14px;
  margin-top: 44px;
  h2 {
    font-size: 28px;
    line-height: 24px;
    color: #d0201d;
    font-weight: 900;
  }
`;

export const PrivacyContent = styled.div`
  h4 {
    font-size: 14px;
    line-height: 20px;
    color: #000000;
    font-weight: 900;
    margin-bottom: 16px;
  }
  p {
    font-size: 14px;
    line-height: 20px;
    color: #000000;
    margin-bottom: 16px;
    span {
      font-weight: 900;
    }
  }
  h3 {
    font-size: 20px;
    line-height: 24px;
    color: #d0201d;
    margin-bottom: 16px;
    font-weight: 900;
  }
  ul {
    li {
      position: relative;
      padding-left: 12px;
      margin-bottom: 8px;
      color: #000;
      &::before {
        list-style-type: none;
      }
      ${props =>
        props.theme.rtl &&
        `
                padding-left: 0;
                padding-right: 12px;
                &::before{
                    left: unset;
                    right: 0;
                }
            `};
    }
  }
  b {
    margin-top: 10px;
    display: block;
  }
`;
